<template>
    <el-container>
        <!-- 01.侧边栏 Start -->
        <Side></Side>
        <!-- 01.侧边栏 End -->
        <el-container>
            <!-- 02.置顶导航 Start -->
            <el-header class="ui-header">
                <Header></Header>
            </el-header>
            <!-- 02.置顶导航 End -->
            <!-- 03.主体容器 Start -->
            <el-main class="ui-container">
                <el-dropdown class="ui-tabs-close" @command="clickTabsClose">
                    <el-button>
                        <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="ui-tabs-dropdown">
                        <el-dropdown-item command="present" icon="ion-ios-close-circle">关闭当前</el-dropdown-item>
                        <el-dropdown-item command="other" icon="ion-ios-close-circle">关闭其他</el-dropdown-item>
                        <el-dropdown-item command="all" icon="ion-ios-close-circle">关闭全部</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-tabs class="ui-tabs" v-model="pageActive" type="card" closable @tab-remove="removePage" @tab-click="changePage">
                    <el-tab-pane v-for="(item,index) in this.$store.state.pageOptions" :key="index" :label="item.name" :name="item.url">
                        <keep-alive v-if="$route.meta.keepAlive">
                            <router-view v-if="item.url === pageActive"/>
                        </keep-alive>
                        <router-view v-else/>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <!-- 03.主体容器 End -->
        </el-container>
    </el-container>
</template>

<script>
    import Side from "./side"
    import Header from "./header"

    export default {
        name: "index",
        components: {Side, Header},
        data() {
            return {}
        },
        // 监听属性
        computed: {
            pageActive: {
                get() {
                    return this.$store.state.pageActive
                },
                set(val) {
                    this.$store.state.pageActive = val
                }
            }
        },
        // 方法集合
        methods: {
            // 01.关闭Tabs页面
            removePage(targetName) {
                if (targetName !== "/manage/home") {
                    // 检测当前已打开Tabs Page数组
                    let tabs_value = []
                    for (let data in JSON.parse(localStorage.getItem("pageOptions"))) {
                        if (targetName !== JSON.parse(localStorage.getItem("pageOptions"))[data].url) {
                            tabs_value.push(JSON.parse(localStorage.getItem("pageOptions"))[data])
                        }
                    }
                    // 删除当前所属Tabs Page数组项
                    this.$store.state.pageOptions = tabs_value
                    localStorage.setItem("pageOptions", JSON.stringify(tabs_value))
                    // 切换至当前已打开Tabs Page数组最后一项
                    let url_value = ""
                    for (let data in JSON.parse(localStorage.getItem("pageOptions"))) {
                        url_value = JSON.parse(localStorage.getItem("pageOptions"))[data].url
                    }
                    this.$router.replace(url_value)
                    this.$store.state.pageActive = url_value
                    localStorage.setItem("pageActive", JSON.stringify(url_value))
                }
            },
            // 02.切换Tabs页面
            changePage(targetName) {
                this.$router.replace(targetName.paneName)
            },
            // 03.Tabs页面按钮组
            clickTabsClose(command) {
                // 关闭当前 ( present )
                if (command === "present") {
                    if (this.$store.state.pageActive !== "/manage/home") {
                        let tabs_value = []
                        let url_value = ""
                        let tabs_present = this.$store.state.pageOptions
                        let url_present = this.$store.state.pageActive
                        // 获取当前url并筛选出其他数据
                        for (let data in tabs_present) {
                            if (url_present !== tabs_present[data].url) {
                                tabs_value.push({
                                    "url": tabs_present[data].url,
                                    "name": tabs_present[data].name
                                })
                            }
                        }
                        // 获取最后一个Tabs 页面
                        for (let data in tabs_value) {
                            url_value = tabs_value[data].url
                        }
                        // 赋值
                        localStorage.setItem("pageOptions", JSON.stringify(tabs_value))
                        localStorage.setItem("pageActive", JSON.stringify(url_value))
                        this.$store.state.pageOptions = tabs_value
                        this.$store.state.pageActive = url_value
                        // 跳转
                        this.$router.replace(url_value)
                    }
                }
                // 关闭其他 ( other )
                if (command === "other") {
                    let tabs_value = []
                    if (this.$store.state.pageActive !== "/manage/home") {
                        tabs_value = [{'url': '/manage/home', 'name': '工作台'}]
                    } else {
                        tabs_value = []
                    }
                    // 获取当前url并筛选出其他数据
                    let url_other = this.$store.state.pageActive
                    for (let data in this.$store.state.pageOptions) {
                        if (url_other === this.$store.state.pageOptions[data].url) {
                            tabs_value.push({
                                "url": this.$store.state.pageOptions[data].url,
                                "name": this.$store.state.pageOptions[data].name
                            })
                        }
                    }
                    // 赋值
                    localStorage.setItem("pageOptions", JSON.stringify(tabs_value))
                    localStorage.setItem("pageActive", JSON.stringify(url_other))
                    this.$store.state.pageOptions = tabs_value
                    this.$store.state.pageActive = url_other
                    // 跳转
                    this.$router.replace(url_other)
                }
                // 关闭全部 ( all )
                if (command === "all") {
                    let tabs_value = [{'url': '/manage/home', 'name': '工作台'}]
                    let url_value = "/manage/home"
                    // 赋值
                    localStorage.setItem("pageOptions", JSON.stringify(tabs_value))
                    localStorage.setItem("pageActive", JSON.stringify(url_value))
                    this.$store.state.pageOptions = tabs_value
                    this.$store.state.pageActive = url_value
                    // 跳转
                    this.$router.replace(url_value)
                }
            },
        },
    }
</script>
